import React from 'react'
import DemoPage from 'src/components/demo/DemoPage'

export default ({ location: { state = {} } }) => (
  <DemoPage state={ state || {} } />
)